import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterSelected } from "../../features/filter/filterSlice";

function FilterBlog() {
  const status = useSelector((state) => state.filter);
  const [filter, setFilter] = useState("all");
  console.log(filter);
  console.log(status.filterStatus);
  if (status.filterStatus !== filter) setFilter(status.filterStatus);
  const dispatch = useDispatch();
  function onChangeFilter(event) {
    dispatch(filterSelected(event.target.value));
    setFilter(event.target.value);
  }
  return (
    <div className="radio-group">
      {/* <!-- handle filter on button click --> */}
      <div>
        <input
          type="radio"
          name="filter"
          id="lws-all"
          checked={filter === "all"}
          className="radio"
          value="all"
          onChange={onChangeFilter}
        />
        <label htmlFor="lws-all">All</label>
      </div>
      <div>
        <input
          type="radio"
          name="filter"
          id="lws-saved"
          className="radio"
          value="saved"
          checked={filter === "saved"}
          onChange={onChangeFilter}
        />
        <label htmlFor="lws-saved">Saved</label>
      </div>
    </div>
  );
}

export default FilterBlog;
